<template>
  <div v-if="isShow && this.objBaseInfo.channelId == 'WEB'" class="cwt_app_loading" v-bind:class="{ loading_s1: isActive1, loading_s2: isFloatingLayer }">
    <div class="loadingc_c" v-bind:class="{ relativeBrowserWin: isRelativeBrowserWin,relativeElement:!isRelativeBrowserWin }">
      <div class="loading_div_1"></div>
      <div class="loading_div_1"></div>
      <div class="loading_div_1"></div>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';
import { showLoadingToast,closeToast } from 'vant';
export default {
  name: "Loading",
  data() {
    return {
      isShow: this.loading,
      eleParent: "",
      objBaseInfo: {}
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    isFloatingLayer: {
      default: true,
    },
    isRelativeBrowserWin: { //是否相对浏览器窗口定位
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isActive1: function () {
      return !this.isFloatingLayer;
    },
    // isShow: function () {
    //   return this.loading;
    // },
  },
  mounted() {
    const instance = getCurrentInstance();
    if (instance) {
      this.objBaseInfo = instance.appContext.config.globalProperties.$objBaseInfo || {};
    }
    
    if (this.$el && this.$el.parentNode) {
      this.eleParent = this.$el.parentNode;
      if (this.loading && this.isFloatingLayer) {
        this.eleParent.classList.add("loading_parent_s");
      }
    }
  },
  watch: {
    loading(newValue) {
      if (this.objBaseInfo.channelId == "WEB") {
        if (!newValue && this.isFloatingLayer) {
          this.eleParent.classList.remove("loading_parent_s");
        } else if (newValue && this.isFloatingLayer) {
          this.eleParent.classList.add("loading_parent_s");
        }
        this.isShow = newValue;
      } else {
        if (newValue) {
          showLoadingToast({
            forbidClick: true,
            loadingType: 'spinner',
            overlay: true,
            duration: 0,
            zIndex: 20000,
          });
        } else {
          closeToast();
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  .cwt_app_loading {
    display: flex;
    flex-direction: column;
    top: 0;
    left: 0;
    z-index: 2000;
    background-color: $loading-bg-color;
    width: 100%;

    &.loading_s1 {
      justify-content: center;
      height: 15rem;

      .loadingc_c {
        display: flex;
        justify-content: center;
        // padding-top: 1rem;
      }
    }

    &.loading_s2 {
      position: fixed;
      justify-content: flex-start;
      height: 100%;

      .loadingc_c {
        display: flex;
        justify-content: center;
        align-items: center;
        // box-shadow: 0 0 4px rgb(0 0 0 / 5%);
        // height: 7.5rem;
        // width: 36rem;
        top: 50%;
        left: 50%;

        &.relativeBrowserWin {
          position: fixed;
        }

        &.relativeElement {
          height: 100%;
        }
      }
    }
  }
}
/* 手机、平板屏幕 */
@media screen and (min-width: 961px) {
  .cwt_app_loading {
    display: flex;
    flex-direction: column;
    top: 0;
    left: 0;
    z-index: 2000;
    background-color: $loading-bg-color;
    width: 100%;

    &.loading_s1 {
      justify-content: center;
      height: 15rem;

      .loadingc_c {
        display: flex;
        justify-content: center;
        // padding-top: 1rem;
      }
    }

    &.loading_s2 {
      position: absolute;
      justify-content: flex-start;
      height: 100%;

      .loadingc_c {
        display: flex;
        justify-content: center;
        align-items: center;
        // box-shadow: 0 0 4px rgb(0 0 0 / 5%);
        // height: 7.5rem;
        // width: 36rem;
        top: 50%;
        left: 50%;

        &.relativeBrowserWin {
          position: fixed;
        }

        &.relativeElement {
          height: 100%;
        }
      }
    }
  }
}

// .loadingc_c {
// display: flex;
// justify-content: center;
// padding-top: 1rem;

// align-items: center;
// position: fixed;
// // box-shadow: 0 0 4px rgb(0 0 0 / 5%);
// height: 95px;
// width: 360px;
// top: 144px;
// left: 40%;
// }
.loading_div_1 {
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: #68b2ce;
  float: left;
  margin: 0 6px;
  animation: loading_div_1 linear 1s infinite;
  -webkit-animation: loading_div_1 linear 1s infinite;
}

.loading_div_1:nth-child(1) {
  animation-delay: 0s;
}

.loading_div_1:nth-child(2) {
  animation-delay: 0.15s;
}

.loading_div_1:nth-child(3) {
  animation-delay: 0.45s;
}

@keyframes loading_div_1 {
  0%, 60%, 100% {
    transform: scale(1);
  }

  30% {
    transform: scale(3.5);
  }
}

@keyframes loading_div_1 {
  0%, 60%, 100% {
    transform: scale(1);
  }

  30% {
    transform: scale(3.5);
  }
}
</style>
